import { FieldValues, FormState } from 'react-hook-form';
import { useLocation } from 'react-router';

import {
   ActionBar,
   ActionBarElementType,
   FormLeavingEventInterceptor,
   hasLocationBackState,
} from '@dreryk/react-components';

import { PatientFileLocationData } from '../../common/common.types';
import { usePatientDependenciesContext } from '../../dependencies';

type AppointmentOutOfScheduleActionProps<BEAN extends FieldValues> = {
   readonly patientId: number;
   readonly formState: FormState<BEAN>;
};

export const AppointmentOutOfScheduleAction = <BEAN extends FieldValues>(
   props: AppointmentOutOfScheduleActionProps<BEAN>
): JSX.Element | null => {
   const {
      appointmentOutOfScheduleButton: AppointmentOutOfScheduleButton,
      accountConfigurationVerificationEventInterceptor,
   } = usePatientDependenciesContext();

   const location = useLocation();
   const hasBackState = hasLocationBackState<PatientFileLocationData>(location);

   if (hasBackState && !location?.state.data?.showAppointmentOutOfSchedule) {
      return null;
   }
   return (
      <ActionBar.Portal elementType={ActionBarElementType.PRIMARY}>
         {AppointmentOutOfScheduleButton ? (
            <FormLeavingEventInterceptor testId={'appointmentOutOfSchedule'} active={props.formState.isDirty}>
               <AppointmentOutOfScheduleButton
                  patientId={props.patientId}
                  accountConfigurationVerificationEventInterceptor={accountConfigurationVerificationEventInterceptor}
                  compact
               />
            </FormLeavingEventInterceptor>
         ) : null}
      </ActionBar.Portal>
   );
};
